// KEYS
export const RIG_OPERATIONS_KEY = 'GOplan_RigOperations';
export const BRIGADE_ID_KEY = 'GOplan_RigOperation.brigadeId';
export const RIG_ID_KEY = 'GOplan_RigOperation.rigId';
export const RIG_OPERATION_ID_KEY = 'GOplan_RigOperation.id';
export const RIG_OPERATION_STAGES_KEY = 'GOplan_RigOperation.stages';
export const RIG_OPERATION_INDEX_KEY = 'GOplan_RigOperation.index';
export const RIG_OPERATION_FIELD_PREFIX = 'GOplan_RigOperation';
